import React, { useState, useEffect } from 'react'
import { FormGroup, ControlLabel, Input, Radio, RadioGroup } from 'rsuite'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function TextareaRadioForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <FormGroup>
        <ControlLabel className={classNames(isRequired(schema.textarea.validators) && 'required')}>
          {schema.textarea.label}
        </ControlLabel>
        <ErrorMessage error={errors.textarea} />
        <Input
          name={schema.textarea.name}
          componentClass="textarea"
          defaultValue={schema.textarea.value || ''}
          placeholder={schema.textarea.label}
          inputRef={register(isValidators(schema.textarea.validators))}
          disabled={schema.disabled}
        />
      </FormGroup>

      {schema.radio && (
        <Controller
          name={schema.radio.name}
          control={control}
          defaultValue={schema.radio.value || 1}
          rule={register(isValidators(schema.radio.validators))}
          render={(props) => {
            return (
              <RadioGroup
                value={props.value}
                onChange={(value) => {
                  props.onChange(value)
                }}
              >
                {schema.radio.options.map((item) => (
                  <Radio key={item.value} value={item.value} disabled={schema.disabled}>
                    {item.label}
                  </Radio>
                ))}
              </RadioGroup>
            )
          }}
        />
      )}
    </>
  )
}
